
  // Instant Client-Side Grid Sorter for Discount and Price
  function applyGridSorting() {
    var sortSelect = document.querySelector('select[name="sort_by"]');
    var currentSort = sortSelect ? sortSelect.value : '';
    
    // Also check URL param
    var urlParams = new URLSearchParams(window.location.search);
    if (!currentSort && urlParams.has('sort_by')) {
      currentSort = urlParams.get('sort_by');
      if (sortSelect) sortSelect.value = currentSort;
    }

    if (!currentSort || (!currentSort.startsWith('discount-') && !currentSort.startsWith('price-'))) {
      return;
    }

    var productGrid = document.querySelector('#product-grid') || 
                      document.querySelector('.dmart-search-product-grid') || 
                      document.querySelector('.product-grid');
    if (!productGrid) return;

    var cards = Array.from(productGrid.children);
    if (cards.length <= 1) return;

    cards.sort(function(a, b) {
      var cardA = a.querySelector('.dmart-grid-card') || a;
      var cardB = b.querySelector('.dmart-grid-card') || b;

      var discA = parseFloat(cardA.getAttribute('data-discount') || 0);
      var discB = parseFloat(cardB.getAttribute('data-discount') || 0);
      var priceA = parseFloat(cardA.getAttribute('data-price') || 0);
      var priceB = parseFloat(cardB.getAttribute('data-price') || 0);

      if (currentSort === 'discount-descending') {
        return discB - discA;
      } else if (currentSort === 'discount-ascending') {
        return discA - discB;
      } else if (currentSort === 'price-ascending') {
        return priceA - priceB;
      } else if (currentSort === 'price-descending') {
        return priceB - priceA;
      }
      return 0;
    });

    cards.forEach(function(card) {
      productGrid.appendChild(card);
    });
  }

/**
 * DMart Professional De-duplicated Pagination Engine
 * Guaranteed ZERO product repetition across all collections & search pages
 */

(function() {
  var currentPage = 1;
  var isLoading = false;
  var allLoaded = false;
  var seenProductIds = new Set();
  var seenVariantIds = new Set();

  function getBaseUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    return url.toString();
  }

  function getLoadedIds() {
    document.querySelectorAll('.dmart-grid-card, [data-product-id]').forEach(function(el) {
      var pid = el.getAttribute('data-product-id');
      var vid = el.getAttribute('data-variant-id');
      if (pid) seenProductIds.add(pid);
      if (vid) seenVariantIds.add(vid);
    });
  }

  function initDMartPagination() {
    applyGridSorting();
    var productGrid = document.querySelector('#product-grid') || 
                      document.querySelector('.dmart-search-product-grid') || 
                      document.querySelector('.product-grid');

    if (!productGrid) return;

    // Reset tracking on page load
    currentPage = 1;
    isLoading = false;
    allLoaded = false;
    seenProductIds.clear();
    seenVariantIds.clear();
    getLoadedIds();

    // Check if initial pagination exists
    var nextLink = document.querySelector('a.pagination__item--next') || 
                   document.querySelector('a[aria-label*="Next"]') ||
                   document.querySelector('a[aria-label*="next"]') ||
                   document.querySelector('.pagination__item--next a') ||
                   document.querySelector('.pagination__next');

    // Hide old clunky pagination
    var oldPags = document.querySelectorAll('.pagination-wrapper, pagination-wrapper, .pagination, .dmart-search-pagination-wrap');
    oldPags.forEach(function(el) { el.style.display = 'none'; });

    // Remove any existing load more button / end notice
    var existingBtn = document.querySelector('.dmart-load-more-wrap');
    if (existingBtn) existingBtn.remove();
    var existingEnd = document.querySelector('.dmart-infinite-end');
    if (existingEnd) existingEnd.remove();

    if (!nextLink) {
      showEndNotice(productGrid);
      return;
    }

    // Create DMart Styled "LOAD MORE PRODUCTS" Action Bar
    var actionWrap = document.createElement('div');
    actionWrap.className = 'dmart-load-more-wrap';
    actionWrap.innerHTML = '<button type="button" class="dmart-load-more-btn" id="dmartLoadMoreBtn"><span class="dmart-btn-spinner"></span><span class="dmart-btn-text">LOAD MORE PRODUCTS</span></button>';

    var container = productGrid.parentNode;
    container.appendChild(actionWrap);

    var loadBtn = document.getElementById('dmartLoadMoreBtn');
    if (loadBtn) {
      loadBtn.addEventListener('click', function() {
        loadNextPage(productGrid, loadBtn);
      });
    }

    // Optional Smooth Auto-Trigger on scroll
    var scrollLock = false;
    function autoScrollTrigger() {
      if (scrollLock || isLoading || allLoaded) return;
      var rect = loadBtn ? loadBtn.getBoundingClientRect() : null;
      if (rect && rect.top <= window.innerHeight + 200) {
        scrollLock = true;
        loadNextPage(productGrid, loadBtn);
        setTimeout(function() { scrollLock = false; }, 1200);
      }
    }

    window.removeEventListener('scroll', autoScrollTrigger);
    window.addEventListener('scroll', autoScrollTrigger, { passive: true });
  }

  function loadNextPage(productGrid, loadBtn) {
    if (isLoading || allLoaded) return;
    isLoading = true;

    if (loadBtn) {
      loadBtn.classList.add('loading');
      var btnText = loadBtn.querySelector('.dmart-btn-text');
      if (btnText) btnText.textContent = 'LOADING PRODUCTS...';
    }

    var nextPage = currentPage + 1;
    var fetchUrl = new URL(window.location.href);
    fetchUrl.searchParams.set('page', nextPage);

    fetch(fetchUrl.toString())
      .then(function(res) {
        if (!res.ok) throw new Error('Page fetch error');
        return res.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newCards = doc.querySelectorAll('#product-grid > .grid__item, #product-grid > .dmart-search-grid-item, .dmart-search-product-grid > .dmart-search-grid-item, .product-grid > .grid__item');

        var brandNewCardsCount = 0;

        if (newCards && newCards.length > 0) {
          newCards.forEach(function(card) {
            var innerProduct = card.querySelector('.dmart-grid-card, [data-product-id]');
            var pid = innerProduct ? innerProduct.getAttribute('data-product-id') : null;
            var vid = innerProduct ? innerProduct.getAttribute('data-variant-id') : null;

            // STRICT DEDUPLICATION: NEVER append if already present in DOM
            if (pid && seenProductIds.has(pid)) {
              return;
            }
            if (vid && seenVariantIds.has(vid)) {
              return;
            }

            if (pid) seenProductIds.add(pid);
            if (vid) seenVariantIds.add(vid);

            productGrid.appendChild(card);
            brandNewCardsCount++;
          });
          applyGridSorting();

          currentPage = nextPage;

          // Re-sync quantity counters for new cards
          if (window.dmartSyncCartState) {
            window.dmartSyncCartState();
          }

          // Check if there is another page beyond this one
          var nextNextLink = doc.querySelector('a.pagination__item--next') || 
                             doc.querySelector('a[aria-label*="Next"]') ||
                             doc.querySelector('a[aria-label*="next"]');

          if (!nextNextLink || brandNewCardsCount === 0) {
            allLoaded = true;
            if (loadBtn && loadBtn.parentNode) loadBtn.parentNode.remove();
            showEndNotice(productGrid);
          }
        } else {
          allLoaded = true;
          if (loadBtn && loadBtn.parentNode) loadBtn.parentNode.remove();
          showEndNotice(productGrid);
        }

        isLoading = false;
        if (loadBtn && !allLoaded) {
          loadBtn.classList.remove('loading');
          var btnText = loadBtn.querySelector('.dmart-btn-text');
          if (btnText) btnText.textContent = 'LOAD MORE PRODUCTS';
        }
      })
      .catch(function(err) {
        console.error('Error loading next page:', err);
        isLoading = false;
        if (loadBtn) {
          loadBtn.classList.remove('loading');
          var btnText = loadBtn.querySelector('.dmart-btn-text');
          if (btnText) btnText.textContent = 'LOAD MORE PRODUCTS';
        }
      });
  }

  function showEndNotice(productGrid) {
    if (document.querySelector('.dmart-infinite-end')) return;
    var container = productGrid.parentNode;
    var endNotice = document.createElement('div');
    endNotice.className = 'dmart-infinite-end';
    endNotice.innerHTML = '<span class="dmart-end-line"></span><span class="dmart-end-text">✓ You have viewed all products in this collection</span><span class="dmart-end-line"></span>';
    container.appendChild(endNotice);
  }

  document.addEventListener('shopify:section:load', initDMartPagination);
  document.addEventListener('DOMContentLoaded', initDMartPagination);
  if (document.readyState !== 'loading') {
    initDMartPagination();
  }

})();
